import { fetchAggregatedSubmissions, fetchAIOptInStatus, fetchOverallPipelineValue, fetchAccuracyProjectionOverTime, enableAIProjectionsOptIn as enableAIProjectionsOptInRequest, fetchClosedWonValue } from '../api/forecastApi';
import { ENABLE_AI_PROJECTIONS_OPT_IN_FAILED, ENABLE_AI_PROJECTIONS_OPT_IN_STARTED, ENABLE_AI_PROJECTIONS_OPT_IN_SUCCEEDED, FETCH_ACCURACY_PROJECTION_FAILED, FETCH_ACCURACY_PROJECTION_STARTED, FETCH_ACCURACY_PROJECTION_SUCCEEDED, FETCH_AI_PROJECTIONS_OPT_IN_FAILED, FETCH_AI_PROJECTIONS_OPT_IN_STARTED, FETCH_AI_PROJECTIONS_OPT_IN_SUCCEEDED, FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_FAILED, FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_STARTED, FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_SUCCEEDED, FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_FAILED, FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_STARTED, FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_SUCCEEDED, FETCH_PORTAL_WIDE_CADENCE_SUCCEEDED, FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_STARTED, FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_FAILED, FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_SUCCEEDED } from './ActionTypes';
import { getHasForecastingAccess } from '../selectors/authSelectors';
import { getPortalWideCadence } from '../selectors/forecastSelectors';
import { fetchPortalWideCadence } from '../api/forecastApi';
import { fetchCurrencyInfoAction } from './MultiCurrencyActions';
import { ALL_PIPELINES } from '../constants/Pipelines';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Cadence } from '../types/Cadence';
import { getCompanyCurrency } from '../selectors/multiCurrencySelectors';
import { fetchProperties } from './PropertiesActions';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
import { getCurrentDatePortalTz } from '../selectors/dateSelectors';
import { getPipelineFilter } from '../selectors/filtersSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export function fetchAIProjectionsOptIn() {
  return (dispatch, getState) => {
    const state = getState();
    const hasForecastingAccess = getHasForecastingAccess(state);
    dispatch({
      type: FETCH_AI_PROJECTIONS_OPT_IN_STARTED
    });
    if (!hasForecastingAccess) {
      return dispatch({
        type: FETCH_AI_PROJECTIONS_OPT_IN_FAILED
      });
    }
    return fetchAIOptInStatus().then(data => {
      dispatch({
        type: FETCH_AI_PROJECTIONS_OPT_IN_SUCCEEDED,
        payload: data.enabled
      });
    }).catch(error => {
      dispatch({
        type: FETCH_AI_PROJECTIONS_OPT_IN_FAILED
      });
      return logRavenException(error, 'Fetch AI Projections Opt In Status');
    });
  };
}
export function enableAIProjectionsOptIn() {
  return dispatch => {
    dispatch({
      type: ENABLE_AI_PROJECTIONS_OPT_IN_STARTED
    });
    return enableAIProjectionsOptInRequest().then(() => {
      dispatch({
        type: ENABLE_AI_PROJECTIONS_OPT_IN_SUCCEEDED
      });
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "analyze.optIn.successAlert.message"
        }),
        titleText: I18n.text('analyze.optIn.successAlert.title'),
        type: 'success'
      });
    }).catch(error => {
      dispatch({
        type: ENABLE_AI_PROJECTIONS_OPT_IN_FAILED
      });
      return logRavenException(error, 'Enable AI Projections Opt In');
    });
  };
}
function maybeFetchPortalWideCadence() {
  // portal-wide cadence is either set in Redux already (nav from other tab)
  // or needs to be fetched and set in Redux
  return (dispatch, getState) => {
    const state = getState();
    const cadence = getPortalWideCadence(state);
    return new Promise(resolve => {
      if (cadence) {
        resolve(cadence);
      } else {
        fetchPortalWideCadence().then(data => {
          dispatch({
            type: FETCH_PORTAL_WIDE_CADENCE_SUCCEEDED,
            payload: data
          });
          resolve(data.cadence);
        }).catch(error => logRavenException(error, 'Fetch Portal Wide Cadence'));
      }
    });
  };
}
function buildRequestData(state, cadence) {
  var _getPipelineFilter;
  const pipelineId = (_getPipelineFilter = getPipelineFilter(state)) === null || _getPipelineFilter === void 0 ? void 0 : _getPipelineFilter.first();
  const localDateNow = getCurrentDatePortalTz(state);
  const companyCurrency = getCompanyCurrency(state);
  const isAllPipelines = pipelineId === ALL_PIPELINES;
  const pipeline = isAllPipelines ? undefined : [pipelineId];
  return {
    currencyCode: companyCurrency,
    isAllPipelines,
    localDateNow,
    pipelineCadence: cadence,
    pipeline,
    timePeriod: {
      timePeriodOption: 'MONTH',
      timePeriodOffset: 0,
      customStartDate: null,
      customEndDate: null
    }
  };
}

// Dispatch once per app load for unchanging data
export function fetchPrerequisiteAnalyzeData() {
  return dispatch => Promise.all([dispatch(maybeFetchPortalWideCadence()), dispatch(fetchProperties()), dispatch(fetchCurrencyInfoAction()), dispatch(fetchAIProjectionsOptIn())]).catch(error => logRavenException(error, 'Fetch Prerequisite Analyze Data'));
}

// Dispatch on pipeline change
export function fetchPipelineSpecificAnalyzeData() {
  return dispatch => Promise.all([dispatch(fetchAllTeamsThisMonthSubmission()), dispatch(fetchAllTeamsThisMonthPipelineValue()), dispatch(fetchAllTeamsThisMonthClosedWonValue()), dispatch(fetchAccuracyProjection())]);
}
export function fetchAllTeamsThisMonthSubmission() {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_STARTED
    });
    const state = getState();
    const cadence = getPortalWideCadence(state);

    // We only support this feature for monthly cadence, so don't ask
    // BE for this if cadence is not equal to MONTH
    if (cadence !== Cadence.Month) {
      dispatch({
        type: FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_FAILED
      });
      return;
    }
    const requestData = buildRequestData(getState(), cadence);
    fetchAggregatedSubmissions(requestData).then(data => dispatch({
      type: FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_SUCCEEDED,
      payload: data
    })).catch(error => {
      dispatch({
        type: FETCH_ALL_TEAMS_THIS_MONTH_SUBMISSION_FAILED
      });
      return logRavenException(error, 'Fetch aggregated submissions', requestData);
    });
  };
}
export function fetchAllTeamsThisMonthPipelineValue() {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_STARTED
    });
    const state = getState();
    const cadence = getPortalWideCadence(state);
    const requestData = buildRequestData(getState(), cadence);
    fetchOverallPipelineValue(requestData).then(data => dispatch({
      type: FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_SUCCEEDED,
      payload: data
    })).catch(error => {
      dispatch({
        type: FETCH_ALL_TEAMS_THIS_MONTH_PIPELINE_VALUE_FAILED
      });
      return logRavenException(error, 'Fetch overall pipeline value', requestData);
    });
  };
}
export function fetchAllTeamsThisMonthClosedWonValue() {
  return (dispatch, getState) => {
    dispatch({
      type: FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_STARTED
    });
    const state = getState();
    const cadence = getPortalWideCadence(state);
    const requestData = buildRequestData(getState(), cadence);
    fetchClosedWonValue(requestData).then(data => {
      const allTeamsThisMonthClosedWonValue = data ? data.amount : undefined;
      dispatch({
        type: FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_SUCCEEDED,
        payload: allTeamsThisMonthClosedWonValue
      });
    }).catch(error => {
      dispatch({
        type: FETCH_ALL_TEAMS_THIS_MONTH_CLOSED_WON_VALUE_FAILED
      });
      return logRavenException(error, 'Fetch closed won value', requestData);
    });
  };
}
export function fetchAccuracyProjection() {
  return (dispatch, getState) => {
    var _getPipelineFilter2;
    dispatch({
      type: FETCH_ACCURACY_PROJECTION_STARTED
    });
    const state = getState();
    const pipelineId = (_getPipelineFilter2 = getPipelineFilter(state)) === null || _getPipelineFilter2 === void 0 ? void 0 : _getPipelineFilter2.first();
    const isAllPipelines = pipelineId === ALL_PIPELINES;
    fetchAccuracyProjectionOverTime({
      pipelineId: isAllPipelines ? undefined : pipelineId
    }).then(data => {
      dispatch({
        type: FETCH_ACCURACY_PROJECTION_SUCCEEDED,
        payload: data
      });
    }).catch(error => {
      dispatch({
        type: FETCH_ACCURACY_PROJECTION_FAILED
      });
      return logRavenException(error, 'Fetch accuracy projection', {
        pipelineId: isAllPipelines ? undefined : pipelineId
      });
    });
  };
}